import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useMyVisitorPasses } from './api';
import { PassCard } from './pass-card';
import { EmptyState } from '@/components/common/empty-state';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { useCondoContext } from '@/features/auth/use-condo-context';

export function MisPasesContent() {
  const { condoId } = useCondoContext();
  const { data, isLoading } = useMyVisitorPasses();

  const sorted = useMemo(() => {
    const items = data?.items ?? [];
    return [...items].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );
  }, [data]);

  if (isLoading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-20 w-full" />
        ))}
      </div>
    );
  }

  if (sorted.length === 0) {
    return (
      <EmptyState
        title="Sin pases"
        description="Aun no has creado pases de visita. Crea uno para que tu visitante pueda ingresar."
        action={
          <Button asChild size="sm">
            <Link to={`/app/condominios/${condoId}/visitas/crear`}>
              <Plus className="h-4 w-4" />
              Crear pase
            </Link>
          </Button>
        }
      />
    );
  }

  return (
    <div className="space-y-3">
      {sorted.map((pass) => (
        <PassCard key={pass.id} pass={pass} />
      ))}
    </div>
  );
}
